import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/institutional-saving/page.tsx")